import type { GridPos } from "@reagent/sim";

/** World-space size of one grid tile, in Three.js units. */
export const TILE_SIZE = 1;

/**
 * The board is a true 3D scene; the isometric LOOK comes entirely from the
 * camera angle (see CameraRig), not from skewing geometry. So grid coords
 * map straight onto the XZ plane — Y is height (stacking, hover, FX).
 */
export function gridToWorld(pos: GridPos, height = 0): [number, number, number] {
  return [pos.x * TILE_SIZE, height, pos.y * TILE_SIZE];
}
